import React, { Component } from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'
import InlineSVG from 'svg-inline-react'

import PopoverWrapper from './PopoverWrapper'
import TriggerWrapper from './TriggerWrapper'

import iconDropDown from 'assets/icons/dropdown.svg'

const Wrapper = styled.div`
  position: relative;
  height: max-content;
`

const IconWhenPopoverIsOpen = props => props.isPopoverShown &&
  css`
  transform: rotate(540deg);
`
const IconStylingForBlock = props => (props.type === 'block' && props.isPopoverShown) &&
  css`
  & > svg > polygon {
    fill: rgba(0, 0, 0, 0.85);
  }
`

const Icon = styled(InlineSVG)`
  position: absolute;
  top: 5px;
  right: 10px; 

  width: 9px;
  transition: transform .5s ease, fill .2s ease;
  
  & > svg > polygon {
    fill: rgba(255, 255, 255, 0.85);
  }
  
  ${IconWhenPopoverIsOpen}
  ${IconStylingForBlock}
`

class Popover extends Component {

  state = {
    showPopover: false
  }

  hide = () => {
    document.removeEventListener('click', this.handleOutsideClick, false)

    this.setState({
      ...this.state,
      showPopover: false
    })
  }

  handleOutsideClick = e => {
    if (this.node?.contains(e.target)) return

    this.handleClick()
  }

  handleClick = () => {
    const {showPopover} = this.state

    if (!showPopover) {
      document.addEventListener('click', this.handleOutsideClick, false)
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false)
    }

    this.setState({
      ...this.state,
      showPopover: !showPopover
    })
  }

  render = () =>{
    const Trigger = this.props.trigger

    return (
      <Wrapper
        ref={ref => this.node = ref}
      >
        <TriggerWrapper
          onClick={this.handleClick}
          type={this.props.type}
          isPopoverShown={this.state.showPopover}
        >
          <Trigger
            isPopoverShown={this.state.showPopover}
          />

          {this.props.showChevron && (
            <Icon
              src={iconDropDown}
              isPopoverShown={this.state.showPopover}
              type={this.props.type}
            />
          )}
        </TriggerWrapper>

        <CSSTransition
          in={this.state.showPopover}
          timeout={300}
          classNames='item-fade'
          unmountOnExit
        >
          <PopoverWrapper
            position={this.props.position}
            type={this.props.type}
          >
            {this.props.children}
          </PopoverWrapper>
        </CSSTransition>
      </Wrapper>
    )
  }
}

Popover.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  trigger: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  showChevron: PropTypes.bool,
  position: PropTypes.oneOf([
    'bottom',
    'bottom-right',
    'bottom-left',
    'top'
  ]),
  type: PropTypes.oneOf([
    'arrow',
    'block'
  ])
}
Popover.defaultProps = {
  type: 'arrow',
  position: 'bottom'
}

export default Popover

